import React, { useState, useEffect } from "react";
import axiosInstance from "../../../interceptor/axiosInstance";
import { toast } from "react-toastify";

const StudentExtraForm = ({ id, onClose }) => {
  const [formData, setFormData] = useState({
    user: id,
    program: "",
    semester: "",
    section: "",
    gender: "",
  });

  const [programs, setPrograms] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    axiosInstance
      .get(`/programs/details/`)
      .then((response) => {
        const { programs, semesters } = response.data?.data || {};
        setPrograms(programs || []);
        setSemesters(semesters || []);
      })
      .catch((error) => {
        toast.error("Failed to fetch program details.");
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axiosInstance.post("accounts/student/", { ...formData });
      toast.success("Student profile completed successfully!");
      onClose();
    } catch (error) {
      let errorMessage = "Failed to submit form";

      if (error.response && error.response.data) {
        const { message, errors } = error.response.data;

        if (message) {
          errorMessage = message;
        }

        if (errors) {
          const errorDetails = Object.entries(errors)
            .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
            .join("\n");

          errorMessage += `\n${errorDetails}`;
        }
      }

      toast.error(errorMessage);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="user-profile-completion-wrapper">
      <div className="user-profile-completion-header">
        <h2>Complete Student Profile</h2>
        <span className="user-profile-completion-close" onClick={onClose}>
          ×
        </span>
      </div>

      <form onSubmit={handleSubmit} className="user-profile-completion-form">
        <div className="user-profile-completion-row">
          <div className="user-profile-completion-field">
            <label>Program *</label>
            <select
              name="program"
              value={formData.program}
              onChange={handleChange}
              required
            >
              <option value="">Select Program</option>
              {programs.map((program) => (
                <option key={program.id} value={program.name}>
                  {program.name}
                </option>
              ))}
            </select>
          </div>

          <div className="user-profile-completion-field">
            <label>Semester *</label>
            <select
              name="semester"
              value={formData.semester}
              onChange={handleChange}
              required
            >
              <option value="">Select Semester</option>
              {semesters.map((semester) => (
                <option key={semester.id} value={semester.name}>
                  {semester.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="user-profile-completion-row">
          <div className="user-profile-completion-field">
            <label>Section *</label>
            <select
              name="section"
              value={formData.section}
              onChange={handleChange}
              required
            >
              <option value="">Select Section</option>
              {["A", "B", "C", "D", "E", "F", "G"].map((section) => (
                <option key={section} value={section}>
                  {section}
                </option>
              ))}
            </select>
          </div>

          <div className="user-profile-completion-field">
            <label>Gender</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
            >
              <option value="">Select Gender</option>
              <option value="m">Male</option>
              <option value="f">Female</option>
            </select>
          </div>
        </div>

        <div className="user-profile-completion-actions">
          <button
            type="submit"
            disabled={isSubmitting}
            className="user-profile-completion-submit"
          >
            {isSubmitting ? (
              <>
                <span className="user-profile-completion-spinner"></span>
                Completing...
              </>
            ) : (
              "Complete Profile"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StudentExtraForm;
